/* eslint-disable dot-notation */
import makeStyles from '@mui/styles/makeStyles';
import localTheme from 'utils/theme';
import type { Theme } from '@mui/material/styles';

const typeBorderColor = {
  warning: localTheme.palette.warning.dark,
  error: localTheme.palette.error.main,
  info: localTheme.palette.info.main,
};

const typeBackgroundColor = {
  warning: localTheme.palette.warning.contrastText,
  error: localTheme.palette.error.light,
  info: localTheme.palette.info.light,
};

type SeverityType = {
  severity: 'warning' | 'error' | 'info';
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: theme.typography.pxToRem(16),
    gap: theme.typography.pxToRem(12),
    color: theme.palette.darkGrey.main,
    borderRadius: '4px',
    background: ({ severity }: SeverityType) => {
      return typeBackgroundColor[severity];
    },
    border: ({ severity }: SeverityType) => {
      return `1px solid ${typeBorderColor[severity]}`;
    },
  },
}));

export default useStyles;
